import Rest from '../Rest'

export default class ClassEntityService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/class_entities'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  getAllByPeople(peopleId: Number) {
    return this.get('/all', {people_id:peopleId}).then(data => {
      return data
    })
  }
}
